document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('[data-certify-form]');
    if (!form) return;

    const input = form.querySelector('[data-certify-input]');
    const submitBtn = form.querySelector('[data-certify-submit]');
    const resultSection = document.querySelector('[data-certify-result]');
    const errorSection = document.querySelector('[data-certify-error]');
    const errorMessageEl = errorSection ? errorSection.querySelector('[data-certify-error-message]') : null;

    if (!input || !submitBtn || !resultSection || !errorSection) return;

    const fieldNodes = {
        student_name: resultSection.querySelector('[data-certify-field="student_name"]'),
        cert_id: resultSection.querySelector('[data-certify-field="cert_id"]'),
        program: resultSection.querySelector('[data-certify-field="program"]'),
        certificate_type: resultSection.querySelector('[data-certify-field="certificate_type"]'),
        issued_on: resultSection.querySelector('[data-certify-field="issued_on"]'),
    };

    const hide = (el) => el.classList.add('certify__result--hidden', 'certify__error--hidden');
    const showResult = () => {
        errorSection.classList.add('certify__error--hidden');
        resultSection.classList.remove('certify__result--hidden');
    };
    const showError = (message) => {
        resultSection.classList.add('certify__result--hidden');
        if (errorMessageEl && message) errorMessageEl.textContent = message;
        errorSection.classList.remove('certify__error--hidden');
    };
    const resetBoth = () => {
        resultSection.classList.add('certify__result--hidden');
        errorSection.classList.add('certify__error--hidden');
    };

    const setLoading = (isLoading) => {
        submitBtn.disabled = isLoading;
        submitBtn.classList.toggle('certify__btn--loading', isLoading);
    };

    const renderResult = (data) => {
        Object.entries(fieldNodes).forEach(([key, node]) => {
            if (node) node.textContent = data[key] || '—';
        });
        showResult();
    };

    const verify = async (certId) => {
        setLoading(true);
        resetBoth();
        try {
            const res = await fetch(`/api/certificate/verify?cert_id=${encodeURIComponent(certId)}`, {
                headers: { 'Accept': 'application/json' },
            });
            const body = await res.json().catch(() => ({}));

            if (res.ok && body && body.success) {
                renderResult(body.data || {});
                return;
            }

            if (res.status === 400) {
                showError(body.message || 'Please enter a certificate ID.');
                return;
            }

            if (res.status === 404) {
                showError('Double check your ID and try again');
                return;
            }

            showError(body.message || 'Unable to verify right now. Please try again.');
        } catch (err) {
            console.error('certificate verify failed', err);
            showError('Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    form.addEventListener('submit', (e) => {
        e.preventDefault();
        const certId = (input.value || '').trim();
        if (!certId) {
            input.focus();
            showError('Please enter a certificate ID.');
            return;
        }
        verify(certId);
    });

    input.addEventListener('input', () => {
        if (!resultSection.classList.contains('certify__result--hidden') ||
            !errorSection.classList.contains('certify__error--hidden')) {
            resetBoth();
        }
    });
});
